export const formatDoctorName = (user, employee) => {
    if (!user) return 'Нет данных';

    const initials = [user.first_name, user.patronymic]
        .filter(Boolean)
        .map((value) => `${value.trim().charAt(0)}.`)
        .join(' ');
    const fullName = [user.last_name, initials].filter(Boolean).join(' ');
    const post = employee?.post?.title || employee?.post;

    return [post, fullName, user.username && `(${user.username})`]
        .filter(Boolean)
        .join(' ');
};
